// extracted by mini-css-extract-plugin
module.exports = {"root":"_d68572","button":"_3edc6e","is-dark":"_d5b4db","is-light":"_259caa","is-new-light":"_cb54fe","authButton":"_b698c9"};